"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var IntervalScheduler_1 = require("../scheduler/IntervalScheduler");

var DefaultActiveSpeakerDetector = /*#__PURE__*/function () {
  function DefaultActiveSpeakerDetector(realtimeController, selfAttendeeId, hasBandwidthPriorityCallback) {
    var waitIntervalMs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
    var updateIntervalMs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 200;

    _classCallCheck(this, DefaultActiveSpeakerDetector);

    this.realtimeController = realtimeController;
    this.selfAttendeeId = selfAttendeeId;
    this.hasBandwidthPriorityCallback = hasBandwidthPriorityCallback;
    this.waitIntervalMs = waitIntervalMs;
    this.updateIntervalMs = updateIntervalMs;
    this.speakerScores = {};
    this.speakerMuteState = {};
    this.detectorCallbackToHandler = new Map();
    this.detectorCallbackToScoresTimer = new Map();
    this.detectorCallbackToActivityTimer = new Map();
    this.hasBandwidthPriority = false;
    this.mostRecentUpdateTimestamp = {};
  }

  _createClass(DefaultActiveSpeakerDetector, [{
    key: "needUpdate",
    value: function needUpdate(attendeeId) {
      if (!this.activeSpeakers) {
        return true;
      }

      return this.speakerScores[attendeeId] === 0 && this.activeSpeakers.includes(attendeeId) || this.speakerScores[attendeeId] > 0 && !this.activeSpeakers.includes(attendeeId);
    }
  }, {
    key: "updateActiveSpeakers",
    value: function updateActiveSpeakers(policy, callback, attendeeId) {
      if (!this.needUpdate(attendeeId)) {
        return;
      }

      var sortedSpeakers = [];
      var attendeeIds = Object.keys(this.speakerScores);

      for (var i = 0; i < attendeeIds.length; i++) {
        var _attendeeId = attendeeIds[i];
        sortedSpeakers.push({
          attendeeId: _attendeeId,
          activeScore: this.speakerScores[_attendeeId]
        });
      }

      var sortedAttendeeIds = sortedSpeakers.sort(function (s1, s2) {
        return s2.activeScore - s1.activeScore;
      }).filter(function (s) {
        return s.activeScore > 0;
      }).map(function (s) {
        return s.attendeeId;
      });
      this.activeSpeakers = sortedAttendeeIds;
      callback(sortedAttendeeIds);
      var selfIsActive = sortedAttendeeIds.length > 0 && sortedAttendeeIds[0] === this.selfAttendeeId;
      var hasBandwidthPriority = selfIsActive && policy.prioritizeVideoSendBandwidthForActiveSpeaker();
      var hasBandwidthPriorityDidChange = this.hasBandwidthPriority !== hasBandwidthPriority;

      if (hasBandwidthPriorityDidChange) {
        this.hasBandwidthPriority = hasBandwidthPriority;
        this.hasBandwidthPriorityCallback(hasBandwidthPriority);
      }
    }
  }, {
    key: "updateScore",
    value: function updateScore(policy, callback, attendeeId, volume, muted) {
      var activeScore = policy.calculateScore(attendeeId, volume, muted);

      if (this.speakerScores[attendeeId] !== activeScore) {
        this.speakerScores[attendeeId] = activeScore;
        this.mostRecentUpdateTimestamp[attendeeId] = Date.now();
        this.updateActiveSpeakers(policy, callback, attendeeId);
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(policy, callback, scoresCallback, scoresCallbackIntervalMs) {
      var _this = this;

      var handler = function handler(attendeeId, present) {
        if (!present) {
          _this.speakerScores[attendeeId] = 0;
          _this.mostRecentUpdateTimestamp[attendeeId] = Date.now();

          _this.updateActiveSpeakers(policy, callback, attendeeId);

          return;
        }

        _this.realtimeController.realtimeSubscribeToVolumeIndicator(attendeeId, function (attendeeId, volume, muted, _signalStrength) {
          _this.mostRecentUpdateTimestamp[attendeeId] = Date.now();

          if (muted !== null) {
            _this.speakerMuteState[attendeeId] = muted;
          }

          _this.updateScore(policy, callback, attendeeId, volume, muted);
        });
      };

      this.detectorCallbackToHandler.set(callback, handler);
      var activityTimer = new IntervalScheduler_1.default(this.updateIntervalMs);
      activityTimer.start(function () {
        for (var attendeeId in _this.speakerScores) {
          if (Date.now() - _this.mostRecentUpdateTimestamp[attendeeId] > _this.waitIntervalMs) {
            _this.updateScore(policy, callback, attendeeId, 0, _this.speakerMuteState[attendeeId]);
          }
        }
      });
      this.detectorCallbackToActivityTimer.set(callback, activityTimer);

      if (scoresCallback && scoresCallbackIntervalMs) {
        var scoresTimer = new IntervalScheduler_1.default(scoresCallbackIntervalMs);
        scoresTimer.start(function () {
          scoresCallback(_this.speakerScores);
        });
        this.detectorCallbackToScoresTimer.set(callback, scoresTimer);
      }

      this.realtimeController.realtimeSubscribeToAttendeeIdPresence(handler);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(callback) {
      var handler = this.detectorCallbackToHandler.get(callback);
      this.detectorCallbackToHandler.delete(callback);

      if (handler) {
        this.realtimeController.realtimeUnsubscribeToAttendeeIdPresence(handler);
      }

      var activityTimer = this.detectorCallbackToActivityTimer.get(callback);

      if (activityTimer) {
        activityTimer.stop();
        this.detectorCallbackToActivityTimer.delete(callback);
      }

      var scoresTimer = this.detectorCallbackToScoresTimer.get(callback);

      if (scoresTimer) {
        scoresTimer.stop();
        this.detectorCallbackToHandler.delete(callback);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iterator, _step, handler, _iterator2, _step2, activityTimer, _iterator3, _step3, scoresTimer;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iterator = _createForOfIteratorHelper(this.detectorCallbackToHandler.values());

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    handler = _step.value;
                    this.realtimeController.realtimeUnsubscribeToAttendeeIdPresence(handler);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _iterator2 = _createForOfIteratorHelper(this.detectorCallbackToActivityTimer.values());

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    activityTimer = _step2.value;
                    activityTimer.stop();
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                _iterator3 = _createForOfIteratorHelper(this.detectorCallbackToScoresTimer.values());

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    scoresTimer = _step3.value;
                    scoresTimer.stop();
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                this.detectorCallbackToHandler.clear();
                this.detectorCallbackToActivityTimer.clear();
                this.detectorCallbackToScoresTimer.clear();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return DefaultActiveSpeakerDetector;
}();

exports.default = DefaultActiveSpeakerDetector;